<div class="full-size">
  <div class="loader">
    <div>
      <img src="assets/img/loader.gif" alt="loader">
      <p>
        Por favor espera mientras cargamos los datos
      </p>
    </div>
  </div>
</div>
